import { Button, Select } from "antd";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CreateProfileCardWrapper from "../../components/common/CreateProfileCardWrapper";
import { setInfoContent } from "../../redux/slices/common_slice";
import CanadaData from "../../utils/state-cities.json";
import "./OnboardingPage.css";

const { Option } = Select;

const NewLocationForm = ({ formik }) => {
  const dispatch = useDispatch();
  const inputRef = useRef();
  const { t } = useTranslation();
  const handleProvinceChange = (value) => {
    formik.setFieldValue("provinceNew", value);
    formik.setFieldValue("cityNew", undefined);
  };
  const removeFocus = () => {
    if (inputRef.current) {
      inputRef.current.blur();
    }
  };

  const citiesArr = formik.values?.provinceNew
    ? CanadaData?.find((item) => item?.name === formik.values?.provinceNew)
        ?.cities
    : [];
  return (
    <>
      <CreateProfileCardWrapper>
        <h5>What province or territory do you plan to live in?</h5>
        <Select
          className={`custom-common-select-box ${
            formik.touched.provinceNew && formik.errors.provinceNew
              ? "error-fill"
              : formik.values.provinceNew
              ? "data-fill"
              : ""
          }`}
          placeholder="Select province or territory"
          onChange={handleProvinceChange}
          onBlur={formik.handleBlur("provinceNew")}
          value={formik.values.provinceNew}
          allowClear={false}
        >
          {CanadaData.map((province) => (
            <Option key={province?.name} value={province?.name}>
              {province?.name}
            </Option>
          ))}
        </Select>
        {!formik.values.provinceNew &&
        formik.touched.provinceNew &&
        formik.errors.provinceNew ? (
          <div className="error-message">{formik.errors.provinceNew}</div>
        ) : null}
      </CreateProfileCardWrapper>

      <CreateProfileCardWrapper>
        <h5 className="d-flex align-items-center justify-content-between">
          What city or town do you plan to live in, or closest to?
          <Button
            className="border-0 bg-tranaparent w-auto h-auto shadow-none p-0 info-icon-btn"
            onClick={() => {
              dispatch(setInfoContent(t("aboutYou.resources.2")));
            }}
          >
            <img
              src="/assets/images/icons/info-circle-icon.svg"
              alt=""
              className="img-fluid"
            />
          </Button>
        </h5>
        <Select
          ref={inputRef}
          className={`custom-common-select-box ${
            formik.touched.cityNew && formik.errors.cityNew
              ? "error-fill"
              : formik.values.cityNew
              ? "data-fill"
              : ""
          }`}
          placeholder="Select city"
          disabled={!formik.values.provinceNew}
          onChange={(e) => {
            formik.setFieldValue("cityNew", e);
            removeFocus();
          }}
          value={formik.values.cityNew}
          allowClear={false}
          showSearch={true}
        >
          {formik.values.provinceNew &&
            citiesArr?.sort().map((city) => (
              <Option key={city?.name} value={city?.name}>
                {city?.name}
              </Option>
            ))}
        </Select>
        {formik.touched.cityNew && formik.errors.cityNew ? (
          <div className="error-message">{formik.errors.cityNew}</div>
        ) : null}
      </CreateProfileCardWrapper>
    </>
  );
};
export default NewLocationForm;
